//@ts-nocheck
import {
    Button,
    Pagination,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Typography,
    Badge,
} from "@mui/material";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import ReplayIcon from "@mui/icons-material/Replay";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import FolderDeleteOutlinedIcon from '@mui/icons-material/FolderDeleteOutlined';
import CloseIcon from "@mui/icons-material/Close";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SplitButton from "../../cui/commonComponents/SplitButton";
import { OidcIdentityContext } from "@rsmus/react-auth";
import { v4 as uuidv4 } from "uuid";

import { useDataGridColumnWidths } from "../../hooks/useDataGridColumnWidths";
import {
    Column,
    DataGrid,
    Editing,
    FilterRow,
    HeaderFilter,
    Item,
    MasterDetail,
    Scrolling,
    SearchPanel,
    Selection,
    Toolbar,
} from "devextreme-react/data-grid";
import "devextreme/data/odata/store";
import { find, isEmpty, isNull } from "lodash";
import {
    act,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import {
    atom,
    useRecoilState,
    useRecoilValue,
    useResetRecoilState,
} from "recoil";
import {
    GetAllRolesDTO,
    GetAllSitesInfoDTO,
    MDMLegalEntityDTO,
    ServiceBusEnum,
    ServiceMessage,
    SiteConfig,
} from "../../api-client-nswag/taxportal-client";
import { PdcDuoConfigurations } from "../../api-client-nswag/create-sites-client";
import { taxPortalClientApi, createSitesClientApi, rollOverClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import AppNameToggle, {
    getAppName,
} from "../../cui/commonComponents/AppNameToggle";
import useSnackbar from "../../hooks/useSnackbar";
import { SnackbarMessage } from "../../hooks/useSnackbar.types";
import { envProperties } from "../../util/EnvironmentProperties";
import { calculateGridHeight, convertUTCTimeToLocal } from "../../util/Utils";
import { DialogBox } from "./DialogBox";
import { clientData } from "./pages/Addclients";
import SelectClientAndTemplate, {
    PermissionDataType,
} from "./selectClientAndTemplate/SelectClientAndTemplate";
import SelectClientAndTemplateForIS from "./selectClientAndTemplate/SelectClientAndTemplateForIS";
import SelectEditLegalEntities from "./selectClientAndTemplate/SelectEditLegalEntities";
import LegalEntitesEditPermission from "./selectClientAndTemplate/LegalEntitesEditPermission";
import ModifySiteName from "./selectClientAndTemplate/ModifySiteName";
import ModifyDates, {
    storeModifiedDatesForCS,
} from "./selectClientAndTemplate/ModifyDates";
import { SiteHistory } from "./siteHistory/SiteHistory";
import {
    SiteProcessData,
    statusState,
} from "./selectClientAndTemplate/SiteProcessData";
import { SiteProcessDataForCS } from "./selectClientAndTemplate/SiteProcessDataForCS";
import { SiteComments } from "./siteComments/siteComments";

import { dataGridConfig, defaultPageSize } from "../../constants";
import L2UserOption from "./l2SupportOption/L2UserOption";
import { getSites } from "./SitesWithLegalEntities";
import { selectedRowDataTypes } from "./types";
import { AppName } from "../../constants";

interface selectedOptionType {
    value: number;
    label: string | undefined;
}
interface gridLegalEntityType {
    pending: boolean;
    fulfilled: boolean;
    gridLegalData: MDMLegalEntityDTO[];
}
interface roleType {
    name?: string | undefined;
    roleId?: string | undefined;
}
interface GetSiteSettingsDTO {
    id: string | number;
    setting: string;
    description: string;
    value: string;
    actionDisplayName: string;
    actionUrl: string;
}

export const getSiteCreationResponse = atom({
    key: "getSiteCreationResponse",
    default: false,
});

export const getSiteExistResponse = atom({
    key: "getSiteExistResponse",
    default: "",
});

export const getExpandedRowData = atom({
    key: "getExpandedRowData",
    default: null,
});

export const getRoleData = atom<roleType[]>({
    key: "getRoleData",
    default: [{ name: null, RoleId: null }],
});

export const getTaxYearResponse = atom({
    key: "getTaxYearResponse",
    default: null,
});

export const getSiteIdForRow = atom({
    key: "getSiteIdForRow",
    default: null,
});

// Common style for toolbar buttons
const toolbarButtonStyle = {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    padding: "4px",
    border: "1px solid #c4c4c4",
    borderRadius: "3px",
    backgroundColor: "#f8f8f8",
    "&:hover": {
        backgroundColor: "#e8e8e8",
        border: "1px solid #b0b0b0",
    },
    "&:disabled": {
        backgroundColor: "#f8f8f8",
        border: "1px solid #e0e0e0",
    },
    "& svg": {
        fontSize: "18px",
    },
};

// Helper function to get button color based on condition
const getButtonColor = (condition: boolean) =>
    condition ? "rgba(0, 0, 0, 0.26)" : "rgba(0, 0, 0, 0.87)";

export default function CreateSitesAutomate() {
    // NEW: State to track active tab and Others tab data
    const [siteSettingsTabState, setSiteSettingsTabState] = useState({
        activeTab: 0,
        isOthersTabDirty: false,
        othersData: [] as any[],
        pdcDuoRows: [] as PdcDuoConfigurations[],
        isPdcDuoDirty: false,
    });

    const [shouldFetch, setShouldFetch] = useState(false);
    const dataGridRef = useRef(null);
    const [ds, setDs] = useState([]); 
    const [data, setData] = useState<getSites>({
        pending: true,
        data: [],
        totalCount: 0,
    });
    const selection = useRecoilValue(clientData);
    const [selectedData, setSelectedData] = useState([]);
    const [tab, setTab] = useState(1);
    const { showSnackbar } = useSnackbar();
    const { showSuccessSnackbar } = useSnackbar();
    const { user } = useContext(OidcIdentityContext);
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const [selectedOption, setSelectedOption] =
        useState<selectedOptionType | null>(null);
    const [title, setTitle] = useState("");
    const appName = useRecoilValue(getAppName);
    const [status, setStatus] = useRecoilState(statusState);
    const [btnContinueDisable, setBtnContinueDisable] = useState(false);
    const [isCreatingSite, setIsCreatingSite] = useState(false);
    const [activeDiv, setActiveDiv] = useState("ACTIVE");
    const [isDisplayModal, setIsDisplayModal] = useState(false);
    const [id, setId] = useRecoilState<number>(getExpandedRowData);
    const [siteId, setSiteId] = useRecoilState<number>(getSiteIdForRow);
    const [disableEditButton, setDisableEditButton] = useState(false);
    const [searchTerm, setSearchTermState] = useState<string | null | undefined>(
        () => {
            try {
                return sessionStorage.getItem("createSiteSetupSearchTerm") || null;
            } catch {
                return null;
            }
        }
    );

    const setSearchTerm = (value: string | null | undefined) => {
        setSearchTermState(value);
        try {
            if (value) {
                sessionStorage.setItem("createSiteSetupSearchTerm", value);
            } else {
                sessionStorage.removeItem("createSiteSetupSearchTerm");
            }
        } catch (error) {
            console.warn("Failed to save search term to sessionStorage:", error);
        }
    };
    const templateRef = useRef<any>();

    const {
        gridRef: columnWidthGridRef,
        onColumnResized,
        onInitialized,
    } = useDataGridColumnWidths({
        gridId: "createSiteSetupMainGrid",
        defaultColumnWidths: {
            0: 200, // Selection column (checkbox)
            1: 300, // Client Name column
            2: 150, // Site ID column
            3: 250, // Site Name column
            4: 150, // Application Name column
            5: 120, // Tax Year column
            6: 180, // Status column
            7: 150, // Created Date column
            8: 150, // Action column (default width)
        },
    });
    const [roleData, setRolesData] = useRecoilState(getRoleData);
    const [isFlag, setIsFlag] = useRecoilState(getSiteCreationResponse);
    const [isDisplayDates, setisDisplayDates] = useState(false);
    const [checked, setChecked] = useState(false);
    const [isChecked, setisChecked] = useState(false);
    const [isPdcEnabled, setIsPdcEnabled] = useState(false);
    const [siteConfig, setSiteConfig] = useState<SiteConfig>({});
    const [siteExistResponse, setIsSiteExistResponse] =
        useRecoilState(getSiteExistResponse);
    const [siteNameForIS, setsiteNameForIS] = useState("");
    const [pageNumber, setpageNumber] = useState(1);
    const taxYear = useRecoilValue(getTaxYearResponse);
    const taxYearForCS = useRecoilValue(getTaxYearResponse);
    const removeTaxYear = useResetRecoilState(getTaxYearResponse);
    const removeTaxYearForCS = useResetRecoilState(getTaxYearResponse);
    const [isCommentsOpen, setIsCommentsOpen] = useState(false);
    const [dataPermissionFinal, setDataPermissionFinal] = useState<
        PermissionDataType[]
    >([
        {
            mdmClientId: 0,
            clientId: 0,
            clientName: "",
            hqSiteId: 0,
            hqClientName: "",
            suppressFolderCreation: false,
            suppressDropdown: false,
            suppressProjectStatus: false,
            userName: "",
        },
    ]);
    const [siteSettings, setSiteSettings] = useState<GetSiteSettingsDTO[]>([]);
    const [selectionMode, setSelectionMode] = useState("multiple");
    const [selectedRowsData, setSelectedRowsData] =
        useState<selectedRowDataTypes | null>(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const prevKeysRef = useRef<any>([]);
    const prevDataRef = useRef<any>([]);
    const [isDisplayLegalEntities, setIsDisplayLegalEntities] = useState(false);
    const [isDisplaySiteSettings, setisDisplaySiteSettings] = useState(false);
    const [isDisplaySiteName, setIsDisplaySiteName] = useState(false);
    const [isPdcSettingsOpen, setIsPdcSettingsOpen] = useState(false);
    const [pdcSettingsRows, setPdcSettingsRows] = useState<any[]>([]);
    const [isPdcSettingsEditing, setIsPdcSettingsEditing] = useState(false);
    const originalPdcSettingsRef = useRef<Map<number, boolean>>(new Map());
    const [commentCounts, setCommentCounts] = useState<{
        [siteId: number]: number;
    }>({});
    const [isLoadingCommentCount, setIsLoadingCommentCount] = useState(false);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [popup, setPopup] = useState(false);
    const [handleEdit, sethandleEdit] = useState(false);
    const [selectedLegalEntityData, setSelectedLegalEntityData] = useState<any[]>(
        []
    );
    const [removedLegalEntityData, setRemovedLegalEntityData] = useState<any[]>(
        []
    );
    const [legalData, setLegalData] = useState({
        pending: false,
        fulfilled: false,
        gridLegalData: [],
    });
    const [editDataPermissionFinal, seteditDataPermissionFinal] = useState([
        {
            mdmClientId: 0,
            clientId: 0,
            clientName: "",
            hqSiteId: 0,
            hqClientName: "",
            suppressFolderCreation: false,
            suppressDropdown: false,
            suppressProjectStatus: false,
            userName: "",
            isTestSite: null,
            isPDCEnabled: null,
        },
    ]);
    const [isAllSiteSelected, setIsAllSiteSelected] = useState(false);
    const [siteDates, setSiteDates] = useState<SiteConfig>();
    const modifyDates = useRecoilValue<string>(storeModifiedDatesForCS);
    const [recordExistResponse] = useState(SnackbarMessage.RECORD_EXISTS_POPUP);
    const [isAllLegalEntitySelected, setIsAllLegalEntitySelected] = useState(false);
    const fetchData = async () => {
        try {
            setData({ pending: true, data: [], totalCount: 0 });
            const startIndex =
                pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
            const data = await createSitesClientApi.highQ_GetSiteFromTrack(
                activeDiv,
                appName !== null ? appName : "PERF",
                startIndex,
                defaultPageSize
            );
            const rawData = data?.data?.data || [];
            // Ensure each row has a unique key for DataGrid selection
            const uniqueData = rawData.map((item, index) => ({
                ...item,
                _rowId: item.hqSiteId || `inprogress_${startIndex + index}`,
                // Normalize to a strict boolean: true only when truthy-true, null/undefined/false all become false
                isCustomPermissionApplied: item.isCustomPermissionApplied === true,
            }));
            setData({ pending: false, data: uniqueData, totalCount: data?.data.totalCount });
        } catch (error) { }
    };

    const fetchDataBySearch = async () => {
        try {
            setData({ pending: true, data: [], totalCount: 0 });
            const startIndex =
                pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
            const data = await createSitesClientApi.highQ_GetSiteFromTrackSearch(
                activeDiv,
                searchTerm,
                appName !== null ? appName : "PERF"
            );
            const rawData = data?.data?.data || [];
            // Ensure each row has a unique key for DataGrid selection
            const uniqueData = rawData.map((item, index) => ({
                ...item,
                _rowId: item.hqSiteId || `inprogress_${index}`,
                // Normalize to a strict boolean: true only when truthy-true, null/undefined/false all become false
                isCustomPermissionApplied: item.isCustomPermissionApplied === true,
            }));
            setData({ pending: false, data: uniqueData, totalCount: data?.data?.totalCount ?? 0 });
        } catch (error) { }
    };

    useEffect(() => {
        if ((searchTerm === null || searchTerm?.length === 0) && shouldFetch) {
            fetchData();
            setShouldFetch(false);
        }
    }, [activeDiv, searchTerm, pageNumber, appName, shouldFetch]);

    useEffect(() => {
        setpageNumber(1);
        setShouldFetch(true);
        clearSelection();
    }, [appName, activeDiv]);

    // Clear search term when appName changes
    useEffect(() => {
        setSearchTerm(null);
    }, [appName]);

    useEffect(() => {
        if (appName === "IS" && activeDiv === "INPROGRESS") {
            setActiveDiv("ACTIVE");
        }
    }, [appName, activeDiv]);

    useEffect(() => {
        setShouldFetch(true);
    }, [pageNumber, searchTerm]);

    useEffect(() => {
        if (!isNull(searchTerm) && !isEmpty(searchTerm)) {
            clearSelection();
            fetchDataBySearch();
        }
        // eslint-disable-next-line
    }, [activeDiv, appName, pageNumber, searchTerm]);

    useEffect(() => {
        if (tab === 1) {
            setTitle("Select Client and Template");
            // Reset filters when switching to tab 1, keeping only appName
            setSearchTerm(null);
            setActiveDiv("ACTIVE");
            setpageNumber(1);
        }
        if (tab === 2) {
            // if (appName === "TP") setTitle("Select Tax Year");
            //if (appName === "CS") setTitle("Select Dates");
            setTitle("Select Dates");
        }
        if (tab === 3) {
            setTitle("Select Legal Entities");
        }
        if (tab === 4) {
            setTitle("Select Legal Entities Settings");
        }
        if (tab === 5) {
            setTitle("Customize site name");
        }
    }, [tab]);

    useEffect(() => {
        const fetchSiteSettings = async () => {
            try {
                const data = await createSitesClientApi.taxPortal_GetHQSiteSettings();
                setSiteSettings(data);
            } catch (error) {
                console.error("Error fetching site settings:", error);
            }
        };
        fetchSiteSettings();
    }, []);

    // Function to handle div click
    const handleDivClick = (divNumber) => {
        setActiveDiv(divNumber);
    };
    const onSelectionChanged = (e: any) => {
        setSelectedData(e.selectedRowsData);

        const newPageKeys = e.selectedRowKeys;
        const newPageData = e.selectedRowsData;
        const visibleKeys = e.component.getVisibleRows().map((row: any) => row.key);

        const addedKeys = newPageKeys.filter(
            (key: any) => !prevKeysRef.current.includes(key)
        );
        const addedData = newPageData.filter((row: any) =>
            addedKeys.includes(row._rowId)
        );
        const removedKeys = visibleKeys.filter(
            (k: any) => prevKeysRef.current.includes(k) && !newPageKeys.includes(k)
        );

        const updatedKeys = [
            ...prevKeysRef.current.filter((k: any) => !removedKeys.includes(k)),
            ...addedKeys,
        ];

        const updatedData = [
            ...prevDataRef.current.filter(
                (row: any) => !removedKeys.includes(row._rowId)
            ),
            ...addedData,
        ];

        prevKeysRef.current = updatedKeys;
        prevDataRef.current = updatedData;

        const selectedRow = updatedData?.[0];
        const selectedIsTestSite =
            selectedRow?.isTestSite ?? selectedRow?.IsTestSite ?? false;
        setisChecked(!!selectedIsTestSite);
        const selectedIsPdcEnabled =
            selectedRow?.isPDCEnabled ?? selectedRow?.isPdcEnabled ?? false;
        setIsPdcEnabled(!!selectedIsPdcEnabled);

        setSelectedRowKeys(updatedKeys);
        setSelectedData(updatedData);
    };
    const clearSelection = () => {
        setSelectedRowKeys([]);
        prevKeysRef.current = [];
        prevDataRef.current = [];
        setSelectedData([]);
        setisChecked(false);
        setIsPdcEnabled(false);
    };

    const datetime = (e: any) => {
        if (e.data.created === null) {
            return null;
        } else {
            return (
                <div style={{ display: "flex" }}>
                    <div>
                        <div>{convertUTCTimeToLocal(e.data.created)}</div>
                    </div>
                </div>
            );
        }
    };
    const onRemoveMapping = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.REMOVE_MAPPING });
            var siteDetails = {
                userName: user?.profile.preferred_username,
                siteIds: SiteId,
            };
            var response = await createSitesClientApi.taxPortal_ArchiveSites(
                siteDetails
            );
            if (response.isSuccess === true) {
                showSuccessSnackbar({
                    message: SnackbarMessage.REMOVE_MAPPING_SUCCESS,
                });
            } else {
                showSnackbar({
                    message: `${SnackbarMessage.REMOVE_MAPPING_FAIL} ${response.message}`,
                    severity: "error",
                });
            }
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    };

    const onUnarchive = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.UNARCHIVE_SITE });
            var siteDetails = {
                userName: user?.profile.preferred_username,
                siteIds: SiteId,
            };
            var response = await createSitesClientApi.taxPortal_UnarchiveSites(
                siteDetails
            );
            for (var i = 0; i < response?.length; i++) {
                var splitResponse = response[i].split(",");
                if (splitResponse[1] === "Site Exists") {
                    showSnackbar({
                        message: splitResponse[0] + SnackbarMessage.SITE_EXISTS,
                    });
                } else if (response[i] === "Unarchived Successfully") {
                    showSuccessSnackbar({ message: SnackbarMessage.UNARCHIVE_SUCCESS });
                } else if (splitResponse[1] === "Organization Exists") {
                    await delay(2000);
                    showSnackbar({
                        message: splitResponse[0] + SnackbarMessage.ORGANIZATION_EXISTS,
                    });
                } else {
                    showSnackbar({
                        message: SnackbarMessage.UNARCHIVE_FAIL,
                        severity: "error",
                    });
                }
            }
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    };

    const onAddClientId = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.ADDCLIENTID_SITENAME });
            const userName = user?.profile.preferred_username;
            var response = await createSitesClientApi.highQ_UpdateSiteNameWithClientId(
                SiteId,
                appName,
                userName
            );
            for (var i = 0; i < response?.length; i++) {
                if (response[i] === "ClientId Added Successfully") {
                    showSuccessSnackbar({ message: SnackbarMessage.ADDCLIENTID_SUCCESS });
                } else {
                    await delay(2000);
                    showSnackbar({ message: response[i], severity: "error" });
                }
            }
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    };

    // --- SplitButton logic for modal actions ---

    const handleCloseLegalEntites = () => {
        setIsDisplayLegalEntities(false);
        setLegalData({ gridLegalData: [] });
        setSelectedOption(null);
        setSelectionMode("multiple");
        setIsFlag(false);
        sethandleEdit(false);
        setSelectionMode("multiple");
        localStorage.clear();
    };
    const handleCloseSiteSettings = () => {
        setisDisplaySiteSettings(false);
        setLegalData({ gridLegalData: [] });
        setSelectedOption(null);
        sethandleEdit(false);
        localStorage.clear();
    };
    const handleCloseSiteName = () => {
        setIsDisplaySiteName(false);
        setLegalData({ gridLegalData: [] });
        setSelectedOption(null);
        sethandleEdit(false);
        localStorage.clear();
    };
    const handleCloseDates = () => {
        setisDisplayDates(false);
        setSelectedOption(null);
        sethandleEdit(false);
        localStorage.clear();
    };
    const handleEditLegalEntities = () => sethandleEdit(true);
    const handleEditDates = () => {
        sethandleEdit(true);
        setBtnContinueDisable(false);
    };
    const handleHistoryClose = () => setIsHistoryOpen(false);
    const handleNo = () => {
        setisDisplaySiteSettings(true);
        setPopup(false);
    };
    const handleYes = () => {
        try {
            SubmitSiteSettings();
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.SITE_SETTINGS_EDIT_FAIL,
                severity: "error",
            });
        }
        setisDisplaySiteSettings(false);
        setPopup(false);
    };

    const handleContinueLegalEntities = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.LEGAL_ENTITIES_EDIT_SUCCESS });
            var response =
                await createSitesClientApi.taxPortal_DisassociateLegalEntities(
                    editDataPermissionFinal,
                    selectedData[0].hqSiteId,
                    appName,
                    isAllSiteSelected
                );
            setIsDisplayLegalEntities(false);
            sethandleEdit(false);
            setLegalData({ gridLegalData: [] });
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.LEGAL_ENTITIES_EDIT_FAIL,
                severity: "error",
            });
        }
    };
    const SubmitSiteSettings = async () => {
        showSnackbar({ message: SnackbarMessage.SITE_SETTINGS_EDIT_SUCCESS });
        var response = await createSitesClientApi.mDM_UpdateSelectedLegalEntities(
            editDataPermissionFinal,
            selectedData[0].hqSiteId,
            appName
        );
        setisDisplaySiteSettings(false);
        sethandleEdit(false);
        setLegalData({ gridLegalData: [] });
    };
    const handleContinueSiteSettings = async () => {
        // Determine which tab is active
        const { activeTab } = siteSettingsTabState;
        if (activeTab === 0) {
            var response = await createSitesClientApi.mDM_CheckSettingsChange(
                editDataPermissionFinal,
                selectedData[0].hqSiteId
            );
            if (response.data === true) {
                setPopup(true);
            } else {
                SubmitSiteSettings();
            }
        }
        else if (activeTab === 1) {
            // Others tab - new logic
            SubmitOthersTabSettings();
        } else if (activeTab === 2 && siteSettingsTabState.isPdcDuoDirty) {
            try {
                showSnackbar({ message: SnackbarMessage.SITE_SETTINGS_EDIT_SUCCESS });
                await createSitesClientApi.pdc_SaveLegalEntityPdcDuoConfig({
                    siteId: selectedData[0].hqSiteId,
                    pdcDuoConfigurations: siteSettingsTabState.pdcDuoRows,
                });
                setisDisplaySiteSettings(false);
                sethandleEdit(false);
                setLegalData({ gridLegalData: [] });
            } catch (error) {
                showSnackbar({ message: SnackbarMessage.SITE_SETTINGS_EDIT_FAIL, severity: "error" });
            }
        }
    };
    const handleContinueSiteName = async () => {
        try {
            var response = await createSitesClientApi.highQ_ModifySiteName(
                selectedData[0].hqSiteId,
                editDataPermissionFinal,
                appName
            );
            if (response === true) {
                showSuccessSnackbar({
                    message: SnackbarMessage.SITE_NAME_EDIT_SUCCESS,
                });
            } else if (response === false) {
                showSnackbar({
                    message:
                        editDataPermissionFinal[0].hqClientName +
                        SnackbarMessage.SITE_NAME_EXISTS,
                    severity: "error",
                });
            }
            setIsDisplaySiteName(false);
            sethandleEdit(false);
            setLegalData({ gridLegalData: [] });
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.SITE_NAME_EDIT_FAIL,
                severity: "error",
            });
        }
    };
    const handleContinueDates = async () => {
        try {
            const clientDTO = {
                hqSiteId: selectedData[0].hqSiteId,
                siteName: selectedData[0]?.clientName,
                clientName: selectedData[0]?.clientName,
                hqClientName: selectedData[0]?.name,
                mdmClientId: selectedData[0]?.mdmClientId,
                appName: appName !== null ? appName : "PERF",
                siteConfig: modifyDates,
            };
            var response =
                await createSitesClientApi.taxPortal_UpdateClientMappingDetails(
                    selectedData[0].hqSiteId,
                    clientDTO
                );
            setisDisplayDates(false);
            sethandleEdit(false);
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.SITE_DATES_EDIT_FAIL,
                severity: "error",
            });
        }
    };

    const onHistorySelect = () => setIsHistoryOpen(true);

    const openPdcSettings = () => {
        const rows = selectedData.map((site: any) => ({
                hqSiteId: site.hqSiteId,
                name: site.name,
                isPDCEnabled: !!(site.isPDCEnabled ?? site.isPdcEnabled),
            }));
        originalPdcSettingsRef.current = new Map(
            rows.map((row) => [row.hqSiteId, row.isPDCEnabled])
        );
        setPdcSettingsRows(rows);
        setIsPdcSettingsEditing(false);
        setIsPdcSettingsOpen(true);
    };

    const closePdcSettings = () => {
        setIsPdcSettingsEditing(false);
        setIsPdcSettingsOpen(false);
    };

    const updatePdcSetting = (hqSiteId: number, isPDCEnabled: boolean) => {
        setPdcSettingsRows((rows) =>
            rows.map((row) =>
                row.hqSiteId === hqSiteId ? { ...row, isPDCEnabled } : row
            )
        );
    };

    const savePdcSettings = async () => {
        try {
            const changedRows = pdcSettingsRows.filter(
                (site) => originalPdcSettingsRef.current.get(site.hqSiteId) !== site.isPDCEnabled
            );

            if (changedRows.length === 0) {
                closePdcSettings();
                clearSelection();
                return;
            }

            const result = await createSitesClientApi.pdc_UpdatePDCConfiguration(
                changedRows.map((site) => ({
                    hqSiteId: site.hqSiteId,
                    isPDCEnabled: site.isPDCEnabled,
                })),
                appName,
                user?.profile.preferred_username!
            );

            if (!result?.data?.key) {
                throw new Error(SnackbarMessage.PDC_ENABLED_FAILD);
            }

            showSuccessSnackbar({ message: SnackbarMessage.PDC_ENABLED_SUCCESS });
            closePdcSettings();
            clearSelection();
            if (searchTerm) {
                await fetchDataBySearch();
            } else {
                await fetchData();
            }
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.PDC_ENABLED_FAILD, severity: "error" });
        }
    };

    const fetchCommentCount = useCallback(async (siteId: number) => {
        try {
            setIsLoadingCommentCount(true);
            const comments = await createSitesClientApi.taxPortal_GetSiteComments(
                siteId
            );
            const count = comments ? comments.length : 0;

            setCommentCounts((prev) => ({
                ...prev,
                [siteId]: count,
            }));

            return count;
        } catch (error) {
            console.warn(`Failed to fetch comment count for site ${siteId}:`, error);
            return 0;
        } finally {
            setIsLoadingCommentCount(false);
        }
    }, []);

    const onCommentsSelect = (e: string) => {
        setIsCommentsOpen(true);
        // Fetch fresh comment count when opening comments
        if (selectedData.length === 1) {
            const siteId = selectedData[0].hqSiteId;
            if (siteId) {
                fetchCommentCount(siteId);
            }
        }
    };

    const onSelect = (e) => {
        switch (e) {
            case "Add":
                HandleOnClickCreate();
                break;
            case "Legal Entities":
                setIsDisplayLegalEntities(true);
                break;
            case "Site Settings":
                setisDisplaySiteSettings(true);
                break;
            case "Site Name":
                setIsDisplaySiteName(true);
                break;
            case "Update Start and End Dates":
                setSiteId(selectedData[0].hqSiteId);
                setisDisplayDates(true);
                break;
            default:
                break;
        }
    };
    const cellRender = (e: any) => {
        if (e.data.created === null) {
            return null;
        } else {
            return (
                <div style={{ display: "flex" }}>
                    <div>
                        <div>{convertUTCTimeToLocal(e.data.archivedDate)}</div>
                    </div>
                </div>
            );
        }
    };
    const cellRenderRestore = (e: any) => {
        return <div>{convertUTCTimeToLocal(e.data.restoredDate)}</div>;
    };
    const cellRenderForMessage = (e: any) => {
        if (e.data.message === null && e.data.status === null) {
            return null;
        }
        return <div title={e.data.message}>{e.data.status}</div>;
    };
    const SiteId = selectedData.map((e) => {
        return e.hqSiteId;
    });
    const cellRenderForStatus = (e: any) => {
        if (status != null && e.data.hqSiteId === status.siteId) {
            return <div title={status.status}>{status.status}</div>;
        } else {
            return <div title={e.data.message}>{e.data.status}</div>;
        }
    };
    const cellRenderForStatusInProgress = (e: any) => {
        return <div title={e.data.message}>{e.data.status}</div>;
    };

    const cellRenderForClientType = (e: any) => {
        const { isProspectClientSite } = e.data;
        if (isProspectClientSite === null || isProspectClientSite === undefined) {
            return null;
        }
        return <div>{isProspectClientSite ? "Prospect" : "Client"}</div>;
    };
    const refreshButtonOptions = {
        icon: "refresh",
        hint: "Refresh",
        onClick: async () => {
            clearSelection();
            if (searchTerm && searchTerm.length > 0) {
                await fetchDataBySearch();
            } else {
                await fetchData();
            }
        },
        elementAttr: {
            title: "Refresh",
        },
    };

    const uniqueTags = [];
    data?.data?.map((x) => {
        if (uniqueTags.indexOf(x.name) === -1) {
            uniqueTags.push(x.name);
        }
    });

    const onClickRetrySiteCreationWithSelection = async () => {
        try {
            showSuccessSnackbar({ message: SnackbarMessage.RETRY_FOR_SITE_CREATION });
            const selectedData = dataGridRef.current!.instance.getSelectedRowsData();
            const messageForRetry = selectedData.map((e: any) => {
                return {
                    siteId: 0,
                    userName: user?.profile.preferred_username,
                    siteName: e.name,
                    clientName: e.clientName,
                    mdmClientId: e.mdmClientId,
                };
            });
            if (messageForRetry != null) {
                var response = await createSitesClientApi.siteSetUp_CreateSiteVerify(
                    appName,
                    messageForRetry
                );
            }
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    };
    const HandleOnClickCreate = async () => {
        setIsPdcEnabled(appName === AppName.CS);
        setIsDisplayModal(true);
    };

    const HandleOnClickSetUp = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.SITE_SETUP });

            const site = selectedData[0] as GetAllSitesInfoDTO;
            const ids = siteSettings.map((s: GetSiteSettingsDTO) => s.id) as number[];

            const message: SiteCreationMessage = {
                siteId: site.hqSiteId,
                mdmClientId: site.mdmClientId,
                userName: user?.profile.preferred_username,
                settingsIds: ids,
                siteName: site.name,
                appName: appName !== null ? appName : "PERF",
            };
            const result = await createSitesClientApi.siteSetUp_SiteSetUp(message);
            const responseMessage = (result as any)?.data ?? result ?? SnackbarMessage.SITE_SETUP;
            showSnackbar({ message: responseMessage, severity: "success" });
        } catch (error) {
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        } finally {
            clearSelection();
        }
    };

    const HandleRemoveRollover = async () => {
        try {
            showSnackbar({ message: SnackbarMessage.ROLLOVER_ARCHIVE_FILE_REMOVAL });
            const data = await Promise.all(selectedData.map(async (e: GetAllSitesInfoDTO) => {
                console.log("Selected Data for Rollover Archive Removal:", e.hqSiteId + " - " + e.year);
                try {
                    const payload = {
                        hqSiteId: e.hqSiteId,
                        taxYear: e.year,
                        rolloverStepName: "Delete_Archival_Folder_From_Site",
                        correlationId: uuidv4(),
                        userName: user?.profile.preferred_username as string,
                        appName: appName !== null ? appName : "TP",
                    }
                    await rollOverClientApi.archiveFile_InsertTopic(payload);
                    showSnackbar({ message: "The rollover archive folder has been removed successfully.", severity: "success" });
                } catch {
                    showSnackbar({ message: "The rollover archive folder removal failed.", severity: "error" });
                }
            }));


        } catch { }
    };

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const rolesData: GetAllRolesDTO[] =
                    await taxPortalClientApi.taxPortal_GetAllRoles();
                setRolesData(rolesData);
            } catch (error) { }
        };
        fetchRoles();
    }, [setRolesData]);

    
     // Submit Exclude 7216 Others tab data
    const SubmitOthersTabSettings = async () => {
        try {
            
            const exclude7216ConsentValue = siteSettingsTabState.othersData.find(
                (setting: any) => setting.setting === "Exclude 7216 Logic"
            )?.value ?? false;
            const isPDCEnabled = siteSettingsTabState.othersData.find(
                (setting: any) => setting.setting === "PDC Enabled"
            )?.value ?? false;
            
            var response = await createSitesClientApi.site_UpdateExclude7216Settings(
                selectedData[0].hqSiteId,
                exclude7216ConsentValue,
                user?.profile.preferred_username,
                isPDCEnabled
            );
            
            showSnackbar({ message: SnackbarMessage.SITE_SETTINGS_EDIT_SUCCESS });
            setisDisplaySiteSettings(false);
            sethandleEdit(false);
            setLegalData({ gridLegalData: [] });
            clearSelection();
            if (searchTerm) {
                await fetchDataBySearch();
            } else {
                await fetchData();
            }
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.SITE_SETTINGS_EDIT_FAIL,
                severity: "error",
            });
        }
    };

    // NEW: Handler for receiving state updates from LegalEntitesEditPermission
    const handleSiteSettingsStateChange = (state: any) => {
    setSiteSettingsTabState(state);
    };
    

    const handleClose = () => {
        setIsDisplayModal(false);
        setTab(1);
        setSelectedOption(null);
        setSelectionMode("multiple");
        setIsFlag(false);
        setChecked(false);
        setisChecked(false);
        setIsPdcEnabled(false);
        setsiteNameForIS("");
        removeTaxYearForCS();
        removeTaxYear();
        localStorage.clear();
    };
    const dropdownSuppression = dataPermissionFinal?.filter(item => item.suppressDropdown
        === true && item.clientId != null).map(item => item.clientId);

    const folderSuppression = dataPermissionFinal?.filter(item => item.suppressFolderCreation
        === true && item.clientId != null).map(item => item.clientId);

    const projectStatusSuppression = dataPermissionFinal?.filter(item => item.suppressProjectStatus
        === true && item.clientId != null).map(item => item.clientId);

    const listData = {
        user: user?.profile.preferred_username as string,
        id: null,
        requestType: "Create Site",
        scriptId: null,
        statusId: null,
        hqSiteId: 0,
        masterClientId: selectedRowsData?.mdmClientId,
        templateId: selectedOption?.value?.toString(),
        siteName: dataPermissionFinal[0]?.hqClientName,
        appName: appName !== null ? appName : "PERF",
        taxYearStartDate: siteConfig?.startDate !== undefined ? siteConfig.startDate : null,
        taxYearEndDate: siteConfig?.endDate !== undefined ? siteConfig.endDate : null,
        includeAllEntities: isAllLegalEntitySelected ? "Yes" : "No",
        filesProcessValidationId: null,
        selectedLegalEntities: [],
        suppressDropdown: dropdownSuppression,
        suppressFolderCreation: folderSuppression,
        suppressProjectStatus: projectStatusSuppression,
        isTestSite: isChecked,
        isPdcEnabled,
        creationSource: "",
        isProspect: appName === "PERF" ? false : selectedRowsData?.isProspect,
    };


    const listDataForIS = {
        hqSiteId: 0,
        user: user?.profile.preferred_username as string,
        id: null,
        requestType: "Create Site",
        scriptId: null,
        statusId: null,
        masterClientId: 0,
        templateId: selectedOption?.value?.toString(),
        siteName: siteNameForIS,
        appName: appName !== null ? appName : "PERF",
        taxYearStartDate: siteConfig?.startDate !== undefined ? siteConfig.startDate : null,
        taxYearEndDate: siteConfig?.endDate !== undefined ? siteConfig.endDate : null,
        includeAllEntities: isAllLegalEntitySelected ? "Yes" : "No",
        filesProcessValidationId: null,
        selectedLegalEntities: [],
        suppressDropdown: dropdownSuppression,
        suppressFolderCreation: [],
        suppressProjectStatus: [],
        isTestSite: isChecked,
        isPdcEnabled,
        creationSource: "",
        isProspect: appName === "PERF" ? false : selectedRowsData?.isProspect,
    };


    const getFilteredAndSortedData = () => {
        const grid = dataGridRef.current?.instance;
        const filterExpr = grid.getCombinedFilter(true);
        const dataSource = grid.getDataSource();
        const loadOptions = dataSource.loadOptions();

        dataSource
            .store()
            .load({
                filter: filterExpr,
                sort: loadOptions.sort,
                group: loadOptions.group,
            })
            .then((result) => {
                setDs(result);
                setTimeout(() => {
                    // Find the input field within the SearchPanel component
                    const input = document.querySelector(
                        ".dx-datagrid-search-panel input"
                    );
                    if (input) {
                        input.focus();
                    }
                }, 100);
            });
    };
    const handleChange = (e: boolean) => {
        setisChecked(e);
    };
    const handlePdcChange = (e: boolean) => {
        setIsPdcEnabled(e);
        seteditDataPermissionFinal((previousData) =>
            previousData.map((item) => ({ ...item, isPDCEnabled: e }))
        );
    };
    const handleContinueForIS = async () => {
        if (isCreatingSite) return;
        if (tab === 1) {
            setTab(tab + 1);
        }
        if (tab === 2) {
            setTab(tab + 1);
        }
        if (tab === 3 && appName === "IS") {
            setIsCreatingSite(true);
            showSnackbar({ message: SnackbarMessage.SITE_CREATION_IN_PROGRESS, severity: "info" });
            try {
                const response = await createSitesClientApi.taxPortal_CreateSites(
                    listDataForIS
                );
                setIsSiteExistResponse(response);
                handleClose();
            } catch (error) {
                showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
            } finally {
                setIsCreatingSite(false);
            }
        }
    };
    const handleContinue = async () => {
        if (isCreatingSite) return;
        if (tab === 5 && tab < 6) {
            setIsCreatingSite(true);
            showSnackbar({ message: SnackbarMessage.SITE_CREATION_IN_PROGRESS, severity: "info" });
            if (selectionMode === "none") {
                try {
                    setIsAllLegalEntitySelected(true);
                    listData['includeAllEntities'] = "Yes";
                    const response = await createSitesClientApi.taxPortal_CreateSites(
                        listData
                    );
                    const isExists = !isNull(response) && !isEmpty(response);
                    if (isExists) {
                        setIsFlag(true);
                        setIsSiteExistResponse(response);
                    } else {
                        setIsDisplayModal(false);
                        handleClose();
                        setIsFlag(false);
                        setChecked(false);
                        setisChecked(false);
                        setIsPdcEnabled(false);
                        localStorage.clear();
                    }
                } catch (error) {
                    showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
                } finally {
                    setIsCreatingSite(false);
                }
                localStorage.clear();
            } else {
                try {
                    listData['selectedLegalEntities'] = dataPermissionFinal?.map(item => item.clientId);
                    setIsAllLegalEntitySelected(false);
                    listData['includeAllEntities'] = "No";
                    const response = await createSitesClientApi.taxPortal_CreateSites(
                        listData
                    );
                    const isExists = !isNull(response) && !isEmpty(response);
                    if (isExists) {
                        setIsFlag(true);
                        setIsSiteExistResponse(response);
                    } else {
                        setIsDisplayModal(false);
                        handleClose();
                        setIsFlag(false);
                        setChecked(false);
                        setisChecked(false);
                        setIsPdcEnabled(false);
                        localStorage.clear();
                    }
                } catch (error) {
                    showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
                } finally {
                    setIsCreatingSite(false);
                }
            }
        } else if (tab === 1 || tab === 2) {
            setTab(tab + 1);
        } else if (tab === 3 || tab === 4) {
            if (selectionMode === "none") {
                if (appName === "TP" || appName === "PERF") {
                    setTab(tab + 2);
                } else if (appName === "CS") {
                    setTab(tab + 2);
                    if (tab === 4) setTab(tab + 1);
                }
            } else if (selectionMode === "multiple") {
                if (appName === "TP" || appName === "PERF") {
                    setTab(tab + 1);
                } else if (appName === "CS") {
                    setTab(tab + 2);
                    if (tab === 4) setTab(tab + 1);
                }
            }
        }
    };
    const handleBack = () => {
        if (tab === 5 && selectionMode === "none") {
            setTab(tab - 2);
            setIsFlag(false);
        } else {
            if (appName === "TP" || appName === "PERF") setTab(tab - 1);
            else if (appName === "CS") {
                if (tab === 5) setTab(tab - 2);
                else setTab(tab - 1);
            } else setTab(tab - 1);
            setChecked(false);
            setisChecked(false);
            setIsPdcEnabled(false);
        }
        if (
            tab === 3 &&
            (appName === "TP" || appName === "CS" || appName === "PERF")
        ) {
            setBtnContinueDisable(false);
        }
    };

    const onRowExpanded = (e) => {
        if (e) {
            setId(e.key);
            e.component.collapseAll(-1);
        }
    };

    const onRowCollapsed = (e) => {
        setStatus({ siteId: SiteId, status: "ACTIVE" });
    };
    const exportButtonOptions = {
        icon: "exportxlsx",
        hint: "Export to Excel",
        onClick: async () => {
            try {
                var status =
                    activeDiv === null
                        ? "All"
                        : activeDiv.charAt(0) + activeDiv.slice(1).toLowerCase();
                var response = await createSitesClientApi
                    .highQ_ExportToExcelForManageSite(appName, activeDiv)
                    .then((res: any) => {
                        const url = URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute(
                            "download",
                            appName + "-" + status + " Client Summary.xlsx"
                        );
                        link.click();
                    });
                showSuccessSnackbar({
                    message: SnackbarMessage.EXPORT_TO_EXCEL_SUCCESS,
                });
            } catch (error) {
                showSnackbar({
                    message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL,
                    severity: "error",
                });
            }
        },
        elementAttr: {
            title: "Export to Excel",
        },
    };
    const cellRenderSiteName = (e: any) => {
        return (
            <>
                {" "}
                {e?.row?.data?.hqSiteId === 0 ? (
                    <div>{e?.row?.data?.name}</div>
                ) : (
                    <div
                        style={{
                            color: "#009cde",
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "inline",
                        }}
                        onClick={() =>
                            window.open(
                                `${envProperties.reactAppHighQSiteUrl}=${e?.row?.data?.hqSiteId}`
                            )
                        }
                    >
                        {e?.row?.data?.name}
                    </div>
                )}
            </>
        );
    };
    const cellRenderMasterClientId = (e: any) => {
        return (
            <div
                style={{
                    color: "#009cde",
                    textDecoration: "underline",
                    cursor: "pointer",
                    display: "inline",
                }}
                onClick={() =>
                    window.open(
                        `${envProperties.reactAppMdmClientIdURL}=${e?.row?.data?.mdmClientId}`
                    )
                }
            >
                {e?.row?.data?.mdmClientId}
            </div>
        );
    };

    // Add the lookup configuration for Yes/No display
    const yesNoLookup = useMemo(() => ({
        dataSource: [
            { value: true, text: "Yes" },
            { value: false, text: "No" }
        ],
        valueExpr: "value",
        displayExpr: "text"
    }), []);

    // Custom header filter data for Yes/No
  const yesNoHeaderFilterData = useMemo(() => [
        { text: "Yes", value: ["exclude7216Consent", "=", true] },
        { text: "No", value: ["exclude7216Consent", "=", false] }
    ], []);

    const cellRenderForCommentsStatus = (e: any) => {
        if (e.data.hasComment === true) return <div title="Y">Y</div>;
        else if (e.data.hasComment === false)
            return <div title="N">N</div>;
    };
    useEffect(() => {
        if (taxYear != null && taxYear != undefined) {
        }
    }, [taxYear]);

    // Fetch comment counts when selection changes
    useEffect(() => {
        const fetchCommentCounts = async () => {
            if (selectedData.length === 1) {
                const siteId = selectedData[0].hqSiteId;
                if (siteId) {
                    await fetchCommentCount(siteId);
                }
            }
        };

        fetchCommentCounts();
    }, [selectedData, fetchCommentCount]);

    const refreshCommentCount = useCallback(async (siteId: number) => {
        try {
            setIsLoadingCommentCount(true);
            const comments = await createSitesClientApi.taxPortal_GetSiteComments(
                siteId
            );
            const count = comments ? comments.length : 0;

            setCommentCounts((prev) => ({
                ...prev,
                [siteId]: count,
            }));

            return count;
        } catch (error) {
            console.warn(
                `Failed to refresh comment count for site ${siteId}:`,
                error
            );
            return 0;
        } finally {
            setIsLoadingCommentCount(false);
        }
    }, []);

    const handleCommentsClose = () => {
        setIsCommentsOpen(false);
        // Refresh comment count after closing comments modal
        if (selectedData.length === 1) {
            const siteId = selectedData[0].hqSiteId;
            if (siteId) {
                refreshCommentCount(siteId);
            }
        }
    };

    // Memoized unique dates for each date field
    const createdDateFilterOptions = useMemo(() => {
        const uniqueDates = new Set<string>();
        data?.data?.forEach((item) => {
            if (item.created) {
                try {
                    const date = new Date(item.created);
                    if (!isNaN(date.getTime())) {
                        uniqueDates.add(date.toISOString().split("T")[0]);
                    }
                } catch (error) {
                    // Skip invalid dates
                }
            }
        });
        return Array.from(uniqueDates)
            .sort()
            .map((date) => ({ text: date, value: date }));
    }, [data?.data]);

    const archivedDateFilterOptions = useMemo(() => {
        const uniqueDates = new Set<string>();
        data?.data?.forEach((item) => {
            if (item.archivedDate) {
                try {
                    const date = new Date(item.archivedDate);
                    if (!isNaN(date.getTime())) {
                        uniqueDates.add(date.toISOString().split("T")[0]);
                    }
                } catch (error) {
                    // Skip invalid dates
                }
            }
        });
        return Array.from(uniqueDates)
            .sort()
            .map((date) => ({ text: date, value: date }));
    }, [data?.data]);

    const restoredDateFilterOptions = useMemo(() => {
        const uniqueDates = new Set<string>();
        data?.data?.forEach((item) => {
            if (item.restoredDate) {
                try {
                    const date = new Date(item.restoredDate);
                    if (!isNaN(date.getTime())) {
                        uniqueDates.add(date.toISOString().split("T")[0]);
                    }
                } catch (error) {
                    // Skip invalid dates
                }
            }
        });
        return Array.from(uniqueDates)
            .sort()
            .map((date) => ({ text: date, value: date }));
    }, [data?.data]);

    const CONSENT_LOOKUP_DATA = Object.freeze([
        { value: "CONSENT", display: "Y" },
        { value: "NO_CONSENT", display: "N" },
        { value: "MIXED_CONSENT", display: "Mixed" },
    ]);

    const HAS_COMMENT_LOOKUP_DATA = Object.freeze([
        { value: true, display: "Y" },
        { value: false, display: "N" },
    ]);

    const consentLookup = useMemo(
        () => ({
            dataSource: CONSENT_LOOKUP_DATA,
            valueExpr: "value",
            displayExpr: "display",
        }),
        []
    );

    const hasCommentLookup = useMemo(
        () => ({
            dataSource: HAS_COMMENT_LOOKUP_DATA,
            valueExpr: "value",
            displayExpr: "display",
        }),
        []
    );

    return (
        <div style={{ margin: "16px" }}>
            <div
                style={{
                    display: "flex",
                    margin: "10px 0 10px 0",
                }}
            >
                <h2>Create and Setup Sites</h2>
                <AppNameToggle />
            </div>
            <div style={{ marginRight: "20px" }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        margin: "10px 0 10px 0",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            width: "21vw",
                            margin: "10px 0 10px 0",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            onClick={() => handleDivClick(null)}
                            style={{
                                cursor: "pointer",
                                color: activeDiv === null ? "#fff" : "black",
                                backgroundColor: activeDiv === null ? "#009cde" : "#eee",
                                borderRadius: "15px",
                                padding: "5px 12px 5px 12px",
                                transition: "background-color 0.3s, color 0.3s",
                            }}
                        >
                            All
                        </div>
                        <div
                            onClick={() => handleDivClick("ACTIVE")}
                            style={{
                                cursor: "pointer",
                                color: activeDiv === "ACTIVE" ? "#fff" : "black",
                                backgroundColor: activeDiv === "ACTIVE" ? "#009cde" : "#eee",
                                borderRadius: "15px",
                                padding: "5px 12px 5px 12px",
                                transition: "background-color 0.3s, color 0.3s",
                                marginLeft: "10px",
                            }}
                        >
                            Active
                        </div>
                        {appName !== AppName.IS && (
                            <div
                                onClick={() => handleDivClick("INPROGRESS")}
                                style={{
                                    cursor: "pointer",
                                    color: activeDiv === "INPROGRESS" ? "#fff" : "black",
                                    backgroundColor:
                                        activeDiv === "INPROGRESS" ? "#009cde" : "#eee",
                                    borderRadius: "15px",
                                    padding: "5px 12px 5px 12px",
                                    transition: "background-color 0.3s, color 0.3s",
                                }}
                            >
                                In Progress
                            </div>
                        )}
                        <div
                            onClick={() => handleDivClick("ARCHIVED")}
                            style={{
                                cursor: "pointer",
                                color: activeDiv === "ARCHIVED" ? "#fff" : "black",
                                backgroundColor: activeDiv === "ARCHIVED" ? "#009cde" : "#eee",
                                borderRadius: "15px",
                                padding: "5px 12px 5px 12px",
                                transition: "background-color 0.3s, color 0.3s",
                            }}
                        >
                            Archived
                        </div>
                    </div>
                </div>
                {appName === AppName.IS ? (
                    <DialogBox
                        isDisplayModal={isDisplayModal}
                        handleClose={handleClose}
                        btnOpenText={tab === 3 ? "Finish" : "Next"}
                        title={
                            tab === 1
                                ? "Select Internal Site Template"
                                : tab === 2
                                    ? "Select Tax Year"
                                    : tab === 3
                                        ? "Customize site name"
                                        : ""
                        }
                        handleContinue={handleContinueForIS}
                        btnBackText={tab !== 1 ? "Back" : ""}
                        handleBack={handleBack}
                        btnContinueDisable={btnContinueDisable || isCreatingSite}
                        isCustomScreen={checked}
                        handleChange={handleChange}
                    >
                        <SelectClientAndTemplateForIS
                            tab={tab}
                            setSelectedRowsData={setSelectedRowsData}
                            selectedOption={selectedOption}
                            selectedRowsData={selectedRowsData}
                            setSelectedOption={setSelectedOption}
                            setBtnContinueDisable={setBtnContinueDisable}
                            setDataPermissionFinal={setDataPermissionFinal}
                            selectionMode={selectionMode}
                            setSelectionMode={setSelectionMode}
                            appName={appName}
                            setIsFlag={setIsFlag}
                            setSiteConfig={setSiteConfig}
                            siteConfig={siteConfig}
                            siteNameForIS={siteNameForIS}
                            setsiteNameForIS={setsiteNameForIS}
                            setChecked={setChecked}
                        />
                    </DialogBox>
                ) : (
                    <DialogBox
                        isDisplayModal={isDisplayModal}
                        handleClose={handleClose}
                        btnOpenText={tab === 5 ? "Finish" : "Next"}
                        title={title}
                        handleContinue={handleContinue}
                        btnBackText={tab !== 1 ? "Back" : ""}
                        handleBack={handleBack}
                        btnContinueDisable={btnContinueDisable || isCreatingSite}
                        isCustomScreen={checked}
                        handleChange={handleChange}
                        showPdcCheckbox={tab === 5}
                        isPdcEnabled={isPdcEnabled}
                        handlePdcChange={handlePdcChange}
                    >
                        <SelectClientAndTemplate
                            tab={tab}
                            setSelectedRowsData={setSelectedRowsData}
                            selectedOption={selectedOption}
                            selectedRowsData={selectedRowsData}
                            setSelectedOption={setSelectedOption}
                            setBtnContinueDisable={setBtnContinueDisable}
                            setDataPermissionFinal={setDataPermissionFinal}
                            selectionMode={selectionMode}
                            setSelectionMode={setSelectionMode}
                            appName={appName}
                            setIsFlag={setIsFlag}
                            setSiteConfig={setSiteConfig}
                            siteConfig={siteConfig}
                            setChecked={setChecked}
                            isAllLegalEntitySelected={isAllLegalEntitySelected}
                            setIsAllLegalEntitySelected={setIsAllLegalEntitySelected}
                        />
                    </DialogBox>
                )}
                <DataGrid
                    keyExpr="_rowId"
                    ref={(instance) => {
                        dataGridRef.current = instance;
                        columnWidthGridRef.current = instance;
                    }}
                    allowColumnResizing={true}
                    columnResizingMode="widget"
                    dataSource={data?.data!}
                    showBorders={true}
                    selectedRowKeys={selectedRowKeys}
                    onSelectionChanged={onSelectionChanged}
                    height={calculateGridHeight(260)}
                    remoteOperations={true}
                    noDataText={data.pending ? "Loading..." : "No Data"}
                    btnContinueDisable={btnContinueDisable}
                    onRowExpanding={onRowExpanded}
                    onContentReady={onInitialized}
                    onOptionChanged={(e) => {
                        if (e.fullName?.includes(".width") && e.value !== e.previousValue) {
                            onColumnResized(e);
                        }
                    }}
                    onRowCollapsed={onRowCollapsed}
                >
                    <Selection
                        mode="multiple"
                        selectAllMode={"page"}
                        showCheckBoxesMode={"always"}
                    />
                    {/* <Paging enabled={true} defaultPageSize={20} /> */}
                    <Scrolling columnRenderingMode="standard" />
                    <FilterRow visible={true} />
                    <HeaderFilter visible={true} />
                    <SearchPanel
                        visible={true}
                        placeholder="Search..."
                        text={searchTerm || ""}
                        onTextChange={(e: any) => {
                            setSearchTerm(e);
                        }}
                    />
                    <Toolbar>
                        <Item location="start">
                            <div className="counter">
                                <h4>
                                    {data.pending
                                        ? "Loading..."
                                        : `${selectedData.length} out of ${data.totalCount} records selected`}
                                </h4>
                            </div>
                        </Item>
                        <Item>
                            <L2UserOption selectedData={selectedData} />
                        </Item>
                        <Item location="after">
                            <SplitButton
                                onSelect={onSelect}
                                options={[
                                    "Add",
                                    "Legal Entities",
                                    "Site Settings",
                                    "Site Name",
                                    "Update Start and End Dates",
                                ]}
                                selection={selectedData?.length}
                                disabled={activeDiv === "INPROGRESS"}
                            />
                        </Item>
                        <Dialog
                            open={popup}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <div style={{ marginTop: "30px" }}>
                                <DialogContent>
                                    <Typography style={{ whiteSpace: "pre-line" }}>
                                        {recordExistResponse}
                                    </Typography>
                                </DialogContent>
                            </div>
                            <DialogActions>
                                <Button
                                    onClick={handleNo}
                                    style={{ margin: "0 16px 0 0" }}
                                    variant="outlined"
                                >
                                    No
                                </Button>
                                <Button
                                    onClick={handleYes}
                                    style={{ margin: "0 16px 0 0" }}
                                    variant="contained"
                                >
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Item location="after">
                            <Button
                                variant="text"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length === 0
                                }
                                onClick={onRemoveMapping}
                                title="Archive"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length === 0
                                    ),
                                }}
                            >
                                <ArchiveOutlinedIcon />
                            </Button>
                        </Item>
                        <Item location="after">
                            <Button
                                variant="text"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length === 0
                                }
                                onClick={onUnarchive}
                                title="Unarchive"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length === 0
                                    ),
                                }}
                            >
                                <UnarchiveOutlinedIcon />
                            </Button>
                        </Item>
                        <Item location="after">
                            <Button
                                variant="text"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length === 0
                                }
                                onClick={onAddClientId}
                                title="Update Site Name with Client ID"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length === 0
                                    ),
                                }}
                            >
                                <DriveFileRenameOutlineIcon />
                            </Button>
                        </Item>
                        {appName !== AppName.IS && (
                            <Item location="after">
                                <Button
                                    variant="text"
                                    disabled={
                                        activeDiv === "INPROGRESS" || selectedData.length === 0
                                    }
                                    onClick={openPdcSettings}
                                    title="PDC Settings"
                                    sx={{
                                        ...toolbarButtonStyle,
                                        color: getButtonColor(
                                            activeDiv === "INPROGRESS" || selectedData.length === 0
                                        ),
                                    }}
                                >
                                    <SettingsOutlinedIcon />
                                </Button>
                            </Item>
                        )}
                        <Item location="after">
                            <>
                                {(activeDiv === "INPROGRESS" || activeDiv === null) && (
                                    <Button
                                        variant="outlined"
                                        onClick={onClickRetrySiteCreationWithSelection}
                                        title="Retry"
                                        sx={{
                                            ...toolbarButtonStyle,
                                            color: getButtonColor(selectedData.length === 0),
                                        }}
                                    >
                                        <ReplayIcon />
                                    </Button>
                                )}
                            </>
                        </Item>
                        <Item location="after">
                            <Button
                                className="custom-toolbar-btn"
                                variant="outlined"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length !== 1
                                }
                                onClick={HandleOnClickSetUp}
                                title="Site Setup"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length !== 1
                                    ),
                                }}
                            >
                                <ChecklistRtlIcon />
                            </Button>
                        </Item>
                        <Item location="after">
                            <Button
                                variant="text"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length !== 1
                                }
                                onClick={onCommentsSelect}
                                title="Comments"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length !== 1
                                    ),
                                }}
                            >
                                <Badge
                                    badgeContent={
                                        selectedData.length === 1
                                            ? commentCounts[selectedData[0].hqSiteId] || 0
                                            : 0
                                    }
                                    color="error"
                                    max={99}
                                    showZero={false}
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            fontSize: "0.7rem",
                                            height: "16px",
                                            minWidth: "16px",
                                            padding: "0 2px",
                                            top: "2px",
                                            right: "2px",
                                        },
                                    }}
                                >
                                    <AddCommentOutlinedIcon />
                                </Badge>
                            </Button>
                        </Item>
                        <Item location="after">
                            <Button
                                className="custom-toolbar-btn"
                                variant="outlined"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length !== 1
                                }
                                onClick={HandleRemoveRollover}
                                title="Delete Rollover"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length !== 1
                                    ),
                                }}
                            >
                                <FolderDeleteOutlinedIcon />
                            </Button>
                        </Item>
                        <Item location="after">
                            <Button
                                variant="text"
                                disabled={
                                    activeDiv === "INPROGRESS" || selectedData.length !== 1
                                }
                                onClick={onHistorySelect}
                                title="History"
                                sx={{
                                    ...toolbarButtonStyle,
                                    color: getButtonColor(
                                        activeDiv === "INPROGRESS" || selectedData.length !== 1
                                    ),
                                }}
                            >
                                <HistoryOutlinedIcon />
                            </Button>
                        </Item>
                        <Item
                            widget="dxButton"
                            options={exportButtonOptions}
                            name="alignRight"
                        />
                        <Item name="searchPanel" location="after" />
                        <Item
                            widget="dxButton"
                            options={refreshButtonOptions}
                            name="alignRight"
                        />
                    </Toolbar>
                    <Column
                        minWidth={80}
                        dataField="hqSiteId"
                        caption="SiteID"
                        alignment="left"
                    ></Column>
                    <Column
                        dataField="orgId"
                        caption="Organisation ID "
                        minWidth={70}
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={80}
                        cellRender={cellRenderMasterClientId}
                        dataField="mdmClientId"
                        caption="Master ClientID"
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={300}
                        dataField="clientName"
                        caption="Master Client Name"
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={400}
                        cellRender={cellRenderSiteName}
                        dataField="name"
                        caption="Site Name"
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={150}
                        cellRender={
                            activeDiv === "ACTIVE"
                                ? cellRenderForStatus
                                : cellRenderForStatusInProgress
                        }
                        dataField="status"
                        caption="Status"
                        alignment="left"
                    ></Column>
                    <Column
                        cellRender={cellRenderForClientType}
                        dataField="Client Type"
                        caption="Client Type"
                        minWidth={105}
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={200}
                        dataField="templateName"
                        caption="Site Template"
                        alignment="left"
                    ></Column>
                    {activeDiv !== "INPROGRESS" &&
                        <Column
                            minWidth={200}
                            dataField="templateNameNew"
                            caption="Upgraded Site Template"
                            alignment="left"
                        ></Column>}
                    <Column
                        dataField="consentStatus"
                        caption="Consent Status"
                        dataType="string"
                        minWidth={150}
                        alignment="left"
                        lookup={consentLookup}
                    />

                    {appName !== "IS" && (
                        <Column
                            dataField="isCustomPermissionApplied"
                            caption="Custom Permissions"
                            dataType="boolean"
                            width={100}
                            alignment="center"
                        />
                    )}

                    <Column
                        dataField="exclude7216Consent"
                        caption="Exclude 7216 Consent"
                        minWidth={150}
                        alignment="left"
                        lookup={yesNoLookup}>
                        <HeaderFilter dataSource={yesNoHeaderFilterData} />
                    </Column>
                    <Column
                        dataField="isPdcEnabled"
                        caption="PDC Enabled"
                        minWidth={150}
                        alignment="left"
                        lookup={yesNoLookup}>
                        <HeaderFilter dataSource={yesNoHeaderFilterData} />
                    </Column>
                    <Column
                        minWidth={150}
                        dataField="hasComment"
                        cellRender={cellRenderForCommentsStatus}
                        caption="Site Comments"
                        alignment="left"
                        lookup={hasCommentLookup}
                    ></Column>
                    <Column
                        minWidth={250}
                        dataField="createdBy"
                        caption="Created by "
                        alignment="left"
                    ></Column>
                    <Column
                        minWidth={200}
                        cellRender={datetime}
                        dataField="created"
                        caption="Created Date "
                        alignment="left"
                    ></Column>
                    <Column
                        dataField="archivedBy"
                        caption="Archived by"
                        minWidth={180}
                        alignment="left"
                    ></Column>
                    <Column
                        cellRender={cellRender}
                        dataField="archivedDate"
                        caption="Archived Date "
                        minWidth={180}
                        alignment="left"
                    ></Column>
                    <Column
                        dataField="restoredBy"
                        caption="Restored by"
                        minWidth={180}
                        alignment="left"
                    ></Column>
                    <Column
                        cellRender={cellRenderRestore}
                        dataField="restoredDate"
                        caption="Restored Date "
                        minWidth={180}
                        alignment="left"
                    ></Column>
                    <MasterDetail
                        enabled={activeDiv === "ACTIVE" ? true : false}
                        ref={templateRef}
                        component={
                            appName === "CS"
                                ? SiteProcessDataForCS
                                : SiteProcessData
                        }
                    ></MasterDetail>
                </DataGrid>
                <DialogBox
                    isDisplayModal={isCommentsOpen}
                    handleClose={handleCommentsClose}
                    title={"Site Comments"}
                    btnContinueDisable={btnContinueDisable}
                >
                    <SiteComments selectedRowData={selectedData[0]} commentSource="CreateandSetupSites"></SiteComments>
                </DialogBox>
                <DialogBox
                    isDisplayModal={isHistoryOpen}
                    handleClose={handleHistoryClose}
                    title={"Site History"}
                    btnContinueDisable={btnContinueDisable}
                >
                    <SiteHistory selectedRowData={selectedData[0]}></SiteHistory>
                </DialogBox>
                <DialogBox
                    isDisplayModal={isPdcSettingsOpen}
                    handleClose={closePdcSettings}
                    handleEdit={() => setIsPdcSettingsEditing(true)}
                    btnEditText="Edit"
                    handleContinue={savePdcSettings}
                    btnOpenText="Save"
                    title="PDC Settings"
                    btnContinueDisable={
                        !isPdcSettingsEditing ||
                        !pdcSettingsRows.some(
                            (site) =>
                                originalPdcSettingsRef.current.get(site.hqSiteId) !== site.isPDCEnabled
                        )
                    }
                    btnEditDisable={isPdcSettingsEditing}
                    dialogContentSx={{ paddingTop: "10px !important" }}
                >
                    <DataGrid
                        {...dataGridConfig}
                        key={`pdc-settings-${isPdcSettingsEditing}`}
                        dataSource={pdcSettingsRows}
                        keyExpr="hqSiteId"
                        onRowUpdated={(event: any) =>
                            updatePdcSetting(event.key, event.data.isPDCEnabled)
                        }
                        height={Math.min(400, Math.max(160, pdcSettingsRows.length * 48 + 80))}
                    >
                        <Editing mode="cell" allowUpdating={isPdcSettingsEditing} />
                        <Scrolling mode="infinite" columnRenderingMode="virtual" />
                        <Column dataField="hqSiteId" caption="Site Id" width={180} />
                        <Column dataField="name" caption="Site Name" minWidth={200} />
                        <Column
                            dataField="isPDCEnabled"
                            caption="PDC Enabled"
                            dataType="boolean"
                            width={200}
                            alignment="center"
                        />
                    </DataGrid>
                </DialogBox>
                <DialogBox
                    isDisplayModal={isDisplaySiteSettings}
                    handleClose={handleCloseSiteSettings}
                    handleEdit={handleEditLegalEntities}
                    btnEditText={"Edit"}
                    handleContinue={handleContinueSiteSettings}
                    btnOpenText={"Save"}
                    title={"Select Legal Entities Settings"}
                    btnContinueDisable={siteSettingsTabState.activeTab === 2 && !siteSettingsTabState.isPdcDuoDirty}
                    btnEditDisable={disableEditButton}
                >
                    <LegalEntitesEditPermission
                        setDataPermission={seteditDataPermissionFinal}
                        handleEdit={handleEdit}
                        appName={appName}
                        dataPermission={editDataPermissionFinal}
                        selectedRowsData={selectedData}
                        setDisableEditButton={setDisableEditButton}
                        onStateChange={handleSiteSettingsStateChange}
                    />
                </DialogBox>
                <DialogBox
                    isDisplayModal={isDisplaySiteName}
                    handleClose={handleCloseSiteName}
                    handleEdit={handleEditLegalEntities}
                    btnEditText={"Edit"}
                    handleContinue={handleContinueSiteName}
                    btnOpenText={"Save"}
                    title={"Customize site name"}
                    btnContinueDisable={btnContinueDisable}
                    isCustomScreen={true}
                    handleChange={handleChange}
                    isCheckedValue={isChecked}
                    showPdcCheckbox={appName !== AppName.IS}
                    isPdcEnabled={isPdcEnabled}
                    handlePdcChange={handlePdcChange}
                >
                    <ModifySiteName
                        selectedRowsData={selectedData}
                        dataPermission={editDataPermissionFinal}
                        setDataPermission={seteditDataPermissionFinal}
                        setBtnContinueDisable={setBtnContinueDisable}
                        handleEdit={handleEdit}
                        isChecked={isChecked}
                        isPdcEnabled={isPdcEnabled}
                    />
                </DialogBox>
                <DialogBox
                    isDisplayModal={isDisplayDates}
                    handleClose={handleCloseDates}
                    handleEdit={handleEditDates}
                    btnEditText={"Edit"}
                    handleContinue={handleContinueDates}
                    btnOpenText={"Save"}
                    title={"Update Start and End Dates"}
                    btnContinueDisable={btnContinueDisable}
                >
                    <ModifyDates
                        selectedRowsData={selectedData}
                        siteDates={siteDates}
                        modifyDates={modifyDates}
                        setBtnContinueDisable={setBtnContinueDisable}
                        handleEdit={handleEdit}
                    />
                </DialogBox>
                <DialogBox
                    isDisplayModal={isDisplayLegalEntities}
                    handleClose={handleCloseLegalEntites}
                    handleEdit={handleEditLegalEntities}
                    btnOpenText={"Save"}
                    title={"Select Legal Entities"}
                    btnEditText={"Edit"}
                    handleContinue={handleContinueLegalEntities}
                    btnContinueDisable={btnContinueDisable}
                >
                    {selectedData.length === 0 ? (
                        <div style={{ padding: 16 }}>
                            Select at least one site to manage legal entities.
                        </div>
                    ) : (
                        <SelectEditLegalEntities
                            selectedRowsData={selectedData}
                            setLegalData={setLegalData}
                            legalData={legalData}
                            setBtnContinueDisable={setBtnContinueDisable}
                            selectedLegalEntityData={selectedLegalEntityData}
                            setSelectedLegalEntityData={setSelectedLegalEntityData}
                            setSelectionMode={setSelectionMode}
                            selectionMode={selectionMode}
                            handleEdit={handleEdit}
                            setDataPermission={seteditDataPermissionFinal}
                            dataPermission={editDataPermissionFinal}
                            setIsAllSiteSelected={setIsAllSiteSelected}
                            isAllSiteSelected={isAllSiteSelected}
                            setRemovedLegalEntityData={setRemovedLegalEntityData}
                            removedLegalEntityData={removedLegalEntityData}
                        />
                    )}
                </DialogBox>
                {!searchTerm && <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        margin: "5px 0 0 0",
                    }}
                >
                    <Pagination
                        onChange={(e: any, pageNumber: any) => setpageNumber(pageNumber)}
                        count={Math.ceil(data.totalCount / defaultPageSize)}
                        variant="outlined"
                        shape="rounded"
                        page={pageNumber}
                    />
                </div>}
            </div>
        </div>
    );
}
